import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function PrivateRoute({ component: Component, ...rest }) {

    const { currentUser } = useAuth()

    return (
        <Route
            {...rest}
            render={props => {
                return currentUser ? <Component {...props} /> : <Redirect to="/" />
            }}
        >
        </Route>
    )
}

export default PrivateRoute

// ova komponenta nam služi za to da ako nismo ulogirani u profil, ne možemo otići na scan route, već nas vraća na login.
